module.exports = __webpack_public_path__ + "static/media/caminito-light.4608d92e.png";